import { createFileRoute } from "@tanstack/react-router";
import EventDetails from "@/components/events/EventDetails";

export const Route = createFileRoute("/events/$eventId")({
	component: () => <EventDetails />,
});
